import {FeatureLayerInfo} from '../../models/FeatureLayerInfo'
import {IQuery} from '../../interfaces/models'
import axios from 'axios'
import {wfsClient} from './wfsClient'

import {getMapService} from '../../reducers/map'
import {IFieldInfo, IStore} from '../../interfaces/reducers'
import {cqlToXmlStringFilter} from '../../helpers'
import {
  Feature,
  Geometry,
  Polygon,
  MultiPolygon,
  MultiLineString,
  LineString,
  MultiPoint,
  Point,
  Extent
} from '../../models'
import {CoordinateSystem} from '../../enums/CoordinateSystem'
import {ISourceApplyEdits, ITypeFeaturesPair} from '../../interfaces/services'
import {Store} from 'redux'
import appConfig from '../../../reducers/appConfig'
import {CadastreFilterToWhere} from '../../../helpers/regHelper'

export class WFSCrudService {
  store: Store<IStore, any>
  constructor(store: Store<IStore, any>) {
    this.store = store
  }
  protected defaultIdentifyCount = 1000
  public execute(layerInfo: FeatureLayerInfo, query: IQuery): Promise<Array<Feature>> {
    const postData = this.getQueryAsXmlString(layerInfo, query)
    return wfsClient
      .postXml<unknown>(layerInfo.sourceDescription.namespacedUrl, postData)
      .then(data => this.geojsonToEsriJson(data as IGeoserverIdentifyResult, layerInfo, !query.returnGeometry))
  }

  public executeForCount(layerInfo: FeatureLayerInfo, query: IQuery): Promise<number> {
    const postData = this.getQueryAsXmlString(layerInfo, query, true)
    return wfsClient.postXml<string>(layerInfo.sourceDescription.namespacedUrl, postData).then(data => {
      const match = (data as unknown as string).match(/numberOfFeatures=\"(\d+)\"/)
      if (match && match.length == 2) {
        return parseInt(match[1])
      }
      throw new Error('!! the returned xml from the server does not contain numberOfFeatures phrase !!')
    })
  }

  public identify(
    featureLayerInfo: FeatureLayerInfo,
    outSR: CoordinateSystem,
    extent: Extent
  ): Promise<{layerInfo: FeatureLayerInfo; features: Array<Feature>; error?: Error}> {
    const coords = extent.getCoordinates() as number[][]
    const layerInfo = featureLayerInfo
    const query = this.store.getState().dataQueries[appConfig.cadastre.schema.url]
    let where = ''
    if (
      [appConfig.cadastre.schema.url, appConfig.cadastre.immovable.url, appConfig.cadastre.building.url].indexOf(
        featureLayerInfo.url
      ) != -1 &&
      query &&
      query.controledQueries['CadFilter']
    ) {
      where = CadastreFilterToWhere(query.controledQueries['CadFilter'].controlValue, featureLayerInfo)
    }

    const qs =
      `SERVICE=WMS&VERSION=1.3.0&REQUEST=GetFeatureInfo&` +
      `QUERY_LAYERS=${featureLayerInfo.sourceDescription.layerName}&LAYERS=${featureLayerInfo.sourceDescription.layerName}&` +
      `exceptions=application%2Fvnd.ogc.se_inimage&INFO_FORMAT=application%2Fgeo%2Bjson&FEATURE_COUNT=${this.defaultIdentifyCount}&X=50&Y=50&` +
      `SRS=${encodeURIComponent(outSR)}&` +
      `STYLES=&WIDTH=101&HEIGHT=101&BBOX=${coords[0][0]}%2C${coords[0][1]}%2C${coords[1][0]}%2C${coords[1][1]}` +
      (where ? `&CQL_FILTER=${encodeURIComponent(where)}` : '')

    return wfsClient
      .getFeatureInfo<unknown>(layerInfo.sourceDescription.namespacedUrl, qs)
      .then(data => ({layerInfo, features: this.geojsonToEsriJson(data as IGeoserverIdentifyResult, layerInfo, false)}))
      .catch(error => ({layerInfo, features: [], error}))
  }

  protected applySingleSourceEdits(
    layerInfo: FeatureLayerInfo,
    adds?: Array<Feature>,
    updates?: Array<Feature>,
    deletes?: Array<Feature>
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      // let addFeatures = this.featuresToFeatures(adds, layerInfo);
      // let updateFeatures = this.featuresToFeatures(updates ? updates : [], layerInfo);
      // let deleteFeatures = this.featuresToFeatures(deletes ? deletes : [], layerInfo);
      // let node = new WFS().writeTransaction(
      //     addFeatures ? addFeatures : [],
      //     updateFeatures ? updateFeatures : [],
      //     deleteFeatures ? deleteFeatures.concat(deleteFeatures) : [],
      //     this.getEditingGML(layerInfo));
      // var xs = new XMLSerializer();
      // var payload = xs.serializeToString(node);
      const payload = this.getTransactionAsXmlString(layerInfo, adds, updates, deletes)
      const layerBase = layerInfo.url.replace(
        '/' + layerInfo.sourceDescription.nameSpace + '/' + layerInfo.sourceDescription.layerName,
        ''
      )
      wfsClient
        .postTransactionXml<string>(layerBase, payload)
        .then(data => {
          if ((data as unknown as string).indexOf('ExceptionReport') != -1) {
            reject()
          }
          if (adds && adds.length > 0) {
            const resultedIds = 0
            const myRegexp = /FeatureId fid="Billboards.(\d+)/g
            let match = myRegexp.exec(data as unknown as string)
            while (match != null) {
              adds[resultedIds].set(layerInfo.sourceDescription.idField, parseInt(match[1]))
              match = myRegexp.exec(data as unknown as string)
            }
          }
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject(e)
        })
    })
  }

  public applyEdits(applyEdits: ISourceApplyEdits[]): Promise<ISourceApplyEdits[]> {
    return new Promise((resolve, reject) => {
      const promises: Promise<void>[] = []
      applyEdits.forEach(a => {
        promises.push(this.applySingleSourceEdits(a.layerInfo, a.adds, a.updates, a.deletes))
      })
      Promise.all(promises)
        .then(r => {
          console.warn('TODO - add ids to adds')
          resolve(applyEdits)
        })
        .catch(error => {
          console.error(error)
          reject(error)
        })
    })
  }

  public attachAttachments(typeFeaturesPair: ITypeFeaturesPair): Promise<Feature[]> {
    throw new Error('not impl')
    return new Promise((resolve, reject) => {
      const result: Feature[] = []

      resolve([])
    })
  }

  protected geojsonToEsriJson(
    result: IGeoserverIdentifyResult,
    featureLayerInfo: FeatureLayerInfo,
    skipGeometry?: boolean
  ): Array<Feature> {
    const features: Array<Feature> = []
    if (!skipGeometry) {
      result.features.forEach(f => {
        f = this.purifyFeature(f, featureLayerInfo)
        let geometry: Geometry | undefined
        if (f.geometry) {
          if (f.geometry.type == 'Polygon') {
            geometry = new Polygon(f.geometry.coordinates)
          } else if (f.geometry.type == 'MultiPolygon') {
            geometry = new MultiPolygon(f.geometry.coordinates)
          } else if (f.geometry.type == 'MultiLineString') {
            geometry = new MultiLineString(f.geometry.coordinates)
          } else if (f.geometry.type == 'LineString') {
            geometry = new LineString(f.geometry.coordinates)
          } else if (f.geometry.type == 'Point') {
            geometry = new Point(f.geometry.coordinates[0])
          } else if (f.geometry.type == 'MultiPoint') {
            geometry = new MultiPoint(f.geometry.coordinates[0])
          } else {
            throw new Error(`Not implemented yet: ${f.geometry.type}`)
          }
        }
        const feat = new Feature()
        feat.setProperties(f.properties)
        if (geometry) {
          feat.setGeometry(geometry)
        }
        features.push(feat)
      })
    } else {
      result.features.forEach(f => {
        f = this.purifyFeature(f, featureLayerInfo)
        const feat = new Feature()
        feat.setProperties(f.properties)
        features.push(feat)
      })
    }
    console.log('features', features)
    return features
  }

  protected purifyFeature(
    feature: IGeoserverIdentifyFeature,
    featureLayerInfo: FeatureLayerInfo
  ): IGeoserverIdentifyFeature {
    for (const fieldName in featureLayerInfo.fields) {
      if (featureLayerInfo.fields[fieldName].type == 'date' && feature.properties[fieldName]) {
        feature.properties[fieldName] = new Date(feature.properties[fieldName]).getTime()
      }
    }
    return feature
  }

  protected getPropertyNames(featureLayerInfo: FeatureLayerInfo, query: IQuery): Array<string> {
    const result: Array<string> = []
    if (query.outFields) {
      for (const field in featureLayerInfo.fields) {
        if (query.returnGeometry && featureLayerInfo.fields[field].type == 'geometry') {
          result.push(field)
        } else if (query.outFields.indexOf(field) != -1 || query.outFields[0] == '*') {
          result.push(field)
        }
      }
    }
    return result
  }

  protected getTransactionAsXmlString(
    featureLayerInfo: FeatureLayerInfo,
    adds?: Array<Feature>,
    updates?: Array<Feature>,
    deletes?: Array<Feature>
  ): string {
    const result: Array<string> = []
    const namespace = featureLayerInfo.sourceDescription.nameSpace
    const layerName = featureLayerInfo.sourceDescription.layerName
    result.push('<Transaction ' + this.getRequestNamespaces() + '>')
    let geometryFieldName = ''
    for (const field in featureLayerInfo.fields) {
      if (featureLayerInfo.fields[field].type == 'geometry') {
        geometryFieldName = field
      }
    }
    if (adds && adds.length > 0) {
      result.push(`<wfs:Insert>
                            <${namespace}:${layerName} xmlns:${namespace}="${namespace}">`)
      adds.forEach(g => {
        if (g.getGeometry() && geometryFieldName) {
          result.push(this.getGeometryAsString(g.getGeometry(), featureLayerInfo, geometryFieldName))
        }
        for (const att in g.getProperties()) {
          if (featureLayerInfo.fields[att]) {
            const fieldInfo = featureLayerInfo.fields[att]
            if (!g.getProperties()[att]) {
              continue
            } else {
              result.push(this.getInsertFieldValue(g.getProperties()[att], fieldInfo, featureLayerInfo))
            }
          }
        }
      })
      result.push(`</${namespace}:${layerName}>
                    </wfs:Insert>`)
    }
    if (updates && updates.length > 0) {
      updates.forEach(g => {
        result.push(`<wfs:Update typeName="${namespace}:${layerName}">`)
        if (!g.getProperties()[featureLayerInfo.sourceDescription.idField]) {
          throw new Error('Missing id')
        }
        if (g.getGeometry() && geometryFieldName) {
          result.push(this.getGeometryAsString(g.getGeometry(), featureLayerInfo, geometryFieldName))
        }
        for (const att in g.getProperties()) {
          if (featureLayerInfo.fields[att] && att != featureLayerInfo.sourceDescription.idField) {
            const fieldInfo = featureLayerInfo.fields[att]
            result.push(this.getUpdateFieldValue(g.getProperties()[att], fieldInfo, featureLayerInfo))
          }
        }
        result.push(
          `<ogc:Filter><ogc:FeatureId fid="${
            g.getProperties()[featureLayerInfo.sourceDescription.idField]
          }"/></ogc:Filter>`
        )
        result.push('</wfs:Update>')
      })
    }
    if (deletes && deletes.length > 0) {
      result.push(`<wfs:Delete typeName="${namespace}:${layerName}">
                            <Filter xmlns="http://www.opengis.net/ogc">`)
      deletes.forEach(g => {
        if (!g.getProperties()[featureLayerInfo.sourceDescription.idField]) {
          throw new Error('Missing id')
        }
        result.push(`<FeatureId fid="${g.getProperties()[featureLayerInfo.sourceDescription.idField]}"/>`)
      })
      result.push(`</Filter>
                    </wfs:Delete>`)
    }

    result.push('</Transaction>')

    return result.join('\n')
  }

  protected getInsertFieldValue(value: any, fieldInfo: IFieldInfo, featureLayerInfo: FeatureLayerInfo): string {
    return `<${fieldInfo.fieldName}>${this.getFieldValue(value, fieldInfo, featureLayerInfo)}</${fieldInfo.fieldName}>`
  }

  protected getUpdateFieldValue(value: any, fieldInfo: IFieldInfo, featureLayerInfo: FeatureLayerInfo): string {
    return `<wfs:Property><wfs:Name>${fieldInfo.fieldName}</wfs:Name><wfs:Value>${this.getFieldValue(
      value,
      fieldInfo,
      featureLayerInfo
    )}</wfs:Value></wfs:Property>`
  }

  protected getFieldValue(value: any, fieldInfo: IFieldInfo, featureLayerInfo: FeatureLayerInfo): string {
    if (value === undefined || value === null) {
      return ``
    }

    if (fieldInfo.type == 'date') {
      if (typeof value == 'number') {
        return `${new Date(value).toISOString()}`
      } else {
        return ``
      }
    } else {
      return `${value}`
    }
  }

  protected getGeometryAsString(
    geometry: Geometry,
    featureLayerInfo: FeatureLayerInfo,
    geometryFieldName: string
  ): string {
    const geomType = geometry.getType()
    const namespace = featureLayerInfo.sourceDescription.nameSpace
    const coordinates = (geometry as any).getCoordinates()
    if (geomType == 'Point') {
      return `<${geometryFieldName} xmlns="${namespace}"><Point xmlns="http://www.opengis.net/gml" srsName="${getMapService().getCode()}">
            <pos srsDimension="2">${coordinates[0]} ${coordinates[1]}</pos></Point></${geometryFieldName}>`
    } else {
      throw new Error(`${geomType} not implemented yet`)
    }
  }

  protected getRequestNamespaces(featureLayerInfo?: FeatureLayerInfo, query?: IQuery, countOnly?: boolean): string {
    let innerContent = ``
    if (featureLayerInfo && query) {
      if (countOnly) {
        innerContent += ` resultType="hits" `
      }
      if (query.start) {
        innerContent += ` startIndex="${query.start}" `
      }
      if (query.num) {
        innerContent += ` count="${query.num}" maxFeatures="${query.num}" `
      }
    }

    return `

            xmlns="http://www.opengis.net/wfs"
            service="WFS"
            version="1.1.0"
            outputFormat="application/json"
            ${innerContent}
            xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"
            xmlns:wfs="http://www.opengis.net/wfs"
            xmlns:gml="http://www.opengis.net/gml"
            xmlns:ogc="http://www.opengis.net/ogc"
            xsi:schemaLocation="http://www.opengis.net/wfs http://schemas.opengis.net/wfs/1.1.0/wfs.xsd"
        `
  }

  protected getQueryContent(featureLayerInfo: FeatureLayerInfo, query: IQuery): string {
    const queryContent: Array<string> = []
    queryContent.push(`<Query
            typeName="${featureLayerInfo.sourceDescription.nameSpace}:${featureLayerInfo.sourceDescription.layerName}"
            srsName="${getMapService().getCode()}"
            xmlns:${featureLayerInfo.sourceDescription.nameSpace}="${featureLayerInfo.sourceDescription.nameSpace}">`)
    for (const fieldName in featureLayerInfo.fields) {
      if (
        !query.outFields ||
        (query.outFields.length == 1 && query.outFields[0] == '*') ||
        query.outFields.indexOf(fieldName) != -1
      ) {
        queryContent.push(`<PropertyName>${fieldName}</PropertyName>`)
      }
    }
    queryContent.push(this.getQueryFilter(featureLayerInfo, query))
    if (query.orderByFields && query.orderByFields.length > 0) {
      const field = query.orderByFields[0].replace(' ASC', '').replace(' DESC', '')
      queryContent.push(`
                <ogc:SortBy>
                    <ogc:SortProperty><ogc:PropertyName>${field}</ogc:PropertyName><ogc:SortOrder>${
                      query.orderByFields[0].indexOf(' ASC') != -1 ? 'ASC' : 'DESC'
                    }</ogc:SortOrder></ogc:SortProperty>
                </ogc:SortBy>
            `)
    }
    queryContent.push('</Query>')
    return queryContent.join('\n')
  }

  protected getQueryFilter(featureLayerInfo: FeatureLayerInfo, query: IQuery): string {
    if (query.where.replace(/ /g, '') == '1=1') {
      return ''
    }
    const queryFilter: Array<string> = []
    queryFilter.push(`<Filter xmlns="http://www.opengis.net/ogc">`)
    queryFilter.push(cqlToXmlStringFilter(query, featureLayerInfo))

    queryFilter.push('</Filter>')
    return queryFilter.join('\n')
  }

  protected getQueryAsXmlString(featureLayerInfo: FeatureLayerInfo, query: IQuery, countOnly?: boolean): string {
    const header = '<GetFeature ' + this.getRequestNamespaces(featureLayerInfo, query, countOnly) + '>'
    const queryContent = this.getQueryContent(featureLayerInfo, query)

    return header + queryContent + '</GetFeature>'
  }
}

interface IGeoserverIdentifyFeature {
  geometry: {
    coordinates: Array<any>
    type: 'MultiPolygon' | 'MultiLineString' | 'Point' | 'LineString' | 'Polygon' | 'GeometryCollection' | 'MultiPoint' //TODO
  }
  geometry_name: string
  id: string
  properties: {[key: string]: any}
}
interface IGeoserverIdentifyResult {
  features: Array<IGeoserverIdentifyFeature>
}

interface WFSWriteGetFeatureOptions {
  featureNS: string
  featurePrefix: string
  featureTypes: string[]
  srsName?: string
  handle?: string
  outputFormat?: string
  maxFeatures?: number
  geometryName?: string
  propertyNames?: string[]
  startIndex?: number
  count?: number
  bbox?: Extent
  filter?: any
  resultType?: string
}
